import history from '../history';
const navExport = function(dispatch) {
    return (event)=>{
        event.preventDefault();
        const url = new URL(event.target.href);
        history.push(url.pathname);
        // dummy action to clear warnings, feedback etc.
        dispatch({
            type: 'meaningless',
            meta: {
                user: true
            }
        });
    };
};
export { navExport };
